
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Acute_myeloid_leukaemia',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Hema/Acute_myeloid_leukaemia.vue